/**
 * AdaptiveGroup (iter1076) — на едър екран рендира децата както досега,
 * на телефон ги събира в сгъваема част (`MobileFoldSection`), която не
 * монтира съдържанието си, докато не бъде отворена. Така таб „Моят ден"
 * се отваря бързо, без да се променя изгледът на едър екран.
 */
import React from "react";
import MobileFoldSection from "./MobileFoldSection";

export const AdaptiveGroup = ({ plain, children, ...fold }) =>
  plain ? <>{children}</> : <MobileFoldSection {...fold}>{children}</MobileFoldSection>;

export default AdaptiveGroup;
